export default __webpack_public_path__ + "static/media/Offre_STAR.e3849022.jpg";